import ReactDOM from "react-dom/client";
import Avm from "../components/Avm";

ReactDOM.createRoot(document.getElementById("app-target")).render(<Avm />);
